'use client';

import { useEffect } from 'react';
import { onINP, onLCP, onCLS } from 'web-vitals';
// import { IS_PROD_ENVIRONMENT } from '@/config/app.config';

/*
  useful to track web vitals
  - prints LCP more often then the default web vitals tracker.
  - enabled INP tracking
*/
export const CustomWebVitalsTracker = () => {
  useEffect(() => {
    // Temporary enable web vitals for prod tracking
    // if (IS_PROD_ENVIRONMENT) {
    //   return;
    // }

    onINP(
      (data) => {
        console.log(
          `Google[INP] duration: ${data.value}, type: ${data.entries[0].name}`
        );
      },
      { reportAllChanges: true }
    );

    onLCP(
      (data) => {
        console.log(
          `Google[LCP] duration: ${data.value}, type: ${data.entries[0].name}`
        );
      },
      { reportAllChanges: true }
    );

    onCLS(
      (data) => {
        console.log(
          `Google[CLS] value: ${data.value}, elements: ${data.entries.map(entry => (entry.sources?.[0]?.node as Element)?.tagName).join(', ')}`
        );
      },
      { reportAllChanges: true }
    );
  }, []);

  return null;
};
